import React, { useState } from "react";
import { Route, Routes } from "react-router-dom";
import AdminGroup from "./AdminGroup";
import AdminGroups from "./AdminGroups";

export default function Groups() {
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(50);
  const [search, setSearch] = useState("");
  const [typeFilter, setTypeFilter] = useState("");

  return (
    <Routes>
      <Route
        index
        element={
          <AdminGroups
            page={page}
            setPage={setPage}
            pageSize={pageSize}
            setPageSize={setPageSize}
            search={search}
            setSearch={setSearch}
            typeFilter={typeFilter}
            setTypeFilter={setTypeFilter}
          />
        }
      />
      <Route path=":groupId/*" element={<AdminGroup />} />
    </Routes>
  );
}
